// TODO: remove this.
var EventEmitter = require("events");

module.exports = new EventEmitter();
